import type { LoginModalEventDetail } from 'js/login_modal/LoginModalManager';

export function lazyOpenLoginModal(
  detail: LoginModalEventDetail,
): Promise<void> {
  return import('js/login_modal/LoginModalManager').then(
    ({ openLoginModal }) => {
      openLoginModal(detail);
    },
  );
}

export default lazyOpenLoginModal;
